import { SVGProps } from "react";

function XIcon({ width, height, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width ?? "7"}
      height={height ?? "6"}
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.02354 2.98688L6.20407 0.806354C6.34864 0.661775 6.34864 0.42739 6.20407 0.282811C6.05949 0.138233 5.8251 0.138233 5.68052 0.282811L3.5 2.46333L1.31948 0.282811C1.1749 0.138233 0.940513 0.138233 0.795934 0.282811C0.651355 0.42739 0.651355 0.661775 0.795934 0.806354L2.97646 2.98688L0.795934 5.1674C0.651355 5.31198 0.651355 5.54636 0.795934 5.69094C0.867977 5.76299 0.962718 5.7995 1.05746 5.7995C1.1522 5.7995 1.24694 5.76348 1.31898 5.69094L3.49951 3.51042L5.68003 5.69094C5.75207 5.76299 5.84681 5.7995 5.94155 5.7995C6.0363 5.7995 6.13104 5.76348 6.20308 5.69094C6.34766 5.54636 6.34766 5.31198 6.20308 5.1674L4.02256 2.98688H4.02354Z"
        fill="#6C757D"
      />
    </svg>
  );
}

export default XIcon;
